import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'antd';
import Icon from '../components/ui-components/Icon';
import ConfirmTick from '../assets/images/confirm-tick.svg';

export const useConfirmPopup = () => {
	const { t } = useTranslation();

	const ConfirmContent = useCallback(
		(content: string) => (
			<div className="flex flex-col font-sans font-normal text-sm">
				<div className="flex flex-col items-center">
					<div className="w-24 h-20 my-4">
						<Icon src={ConfirmTick} className="w-full h-full" />
					</div>
					<div className="text-center my-2">{t(content)}</div>
				</div>
			</div>
		),
		[t]
	);

	const ConfirmFooter = useCallback(
		<T,>({
			action,
			okText,
		}: {
			action?: () => Promise<T> | void;
			okText?: string;
		}) => {
			return (
				<div className="flex w-full gap-4 mt-4">
					<Button
						type="default"
						className="flex-1 h-9 px-4 py-2 font-sans font-bold text-sm border border-primary-blue rounded-lg text-primary-blue"
						onClick={() => Modal.destroyAll()}
					>
						{t('cancel')}
					</Button>
					<Button
						type="default"
						className="flex-1 h-9 px-4 py-2 font-sans font-bold text-sm bg-primary-blue text-white rounded-lg"
						onClick={() => {
							Modal.destroyAll();
							if (action) {
								// eslint-disable-next-line no-console
								Promise.resolve(action()).catch((err) => console.error(err));
							}
						}}
					>
						{t(okText ?? 'submit')}
					</Button>
				</div>
			);
		},
		[t]
	);

	const confirmPopUpAction = useCallback(
		<T,>(
			title: string,
			content: string,
			action?: () => Promise<T> | void,
			okText?: string
		) => {
			Modal.confirm({
				className: 'max-w-md',
				centered: true,
				okText: t('ok'),
				cancelText: t('cancel'),
				icon: null,
				title: (
					<div className="text-center font-sans font-bold text-lg">
						{t(title)}
					</div>
				),
				content: ConfirmContent(content),
				footer: <ConfirmFooter action={action} okText={okText} />,
			});
		},
		[ConfirmContent, t, ConfirmFooter]
	);

	return { confirmPopUpAction };
};
